import * as React from 'react';

export function NoChecks() {
  return (
    <div>
      <p>
        {
          'Здесь будут храниться электронные версии чеков. Для поиска чека по реквизитам нажмите кнопку «Загрузить чек».'
        }{' '}
        {
          'Присвойте чеку «Описание» и «Категорию» для удобства поиска и подбора чеков при оформлении налоговых вычетов.'
        }
      </p>
    </div>
  );
}
